/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-undef */
import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { DeleteOutline, Search, Edit, LocationOn } from '@material-ui/icons';
import './AddressBook.css';
import SignupModal from '../Shared/SignupModal';
import MainBackgroundWrapper from '../Shared/MainBackgroundWrapperForMarketplace';
import NavbarRedesignForMarketplace from '../Shared/NavbarRedesignForMarketplace';
import HelmetTag from '../Shared/HelmetTag';
import PlaceAutoCompleteInput from '../Shared/PlaceAutoCompleteInput';
import ErrorModal from '../Shared/ErrorModal';
import LoadingOverlay from '../Shared/LoadingOverlay';
import { getAddressesOfCurrentUser, addAddressForCurrentUser, deleteAddressOfCurrentUser } from '../Shared/Helpers';
import FinishAddressModal from './FinishAddressModal';
import DefaultAddressConfirmModal from './DefaultAddressConfirmModal';
import DeleteAddressConfirmModal from './DeleteAddressConfirmModal';


class AddressBook extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      addresses: [],
      selectedAddressId: null,
      newAddress: {
        address_line_1: '',
        city: '',
        state: '',
        zip_code: '',
        country: '',
        address_type: 'home',
        default: false,
      },
      loading: false,
      error: '',
      showErrorModal: false,
      addressError: '',
      showFinishAddressModal: false,
      selectedAddressForFinish: null,
      showDefaultConfirmModal: false,
      selectedAddressForDefault: null,
      showDeleteConfirmModal: false,
      selectedAddressForDelete: null,
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleSaveAddress = this.handleSaveAddress.bind(this);
    this.handleCancelAdd = this.handleCancelAdd.bind(this);
    this.handleAddressSelect = this.handleAddressSelect.bind(this);
    this.errorHandler = this.errorHandler.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.handleFinishAddress = this.handleFinishAddress.bind(this);
    this.closeFinishAddressModal = this.closeFinishAddressModal.bind(this);
    this.handleFinishAddressSuccess = this.handleFinishAddressSuccess.bind(this);
    this.handleSetDefault = this.handleSetDefault.bind(this);
    this.closeDefaultConfirmModal = this.closeDefaultConfirmModal.bind(this);
    this.handleDefaultSuccess = this.handleDefaultSuccess.bind(this);
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
    this.closeDeleteConfirmModal = this.closeDeleteConfirmModal.bind(this);
    this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
    this.handleNewAddressFromAutocomplete = this.handleNewAddressFromAutocomplete.bind(this);
    this.addressInputRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      this.setState({ width: window.innerWidth });
    });
    this.loadAddresses();
  }

  loadAddresses() {
    const loggedIn = get(this.props, 'client.loggedIn', false);
    const userId = get(this.props, 'client.user_id');
    
    if (loggedIn && userId) {
      this.setState({ loading: true });
      getAddressesOfCurrentUser(userId, (response) => {
        const addresses = response?.data?.addresses || [];
        this.setState({ 
          addresses,
          loading: false 
        });
      }, (err) => {
        console.log('Error loading addresses:', err);
        this.setState({ 
          loading: false,
          error: 'Failed to load addresses'
        });
      });
    } else {
      // For demo purposes, add sample addresses when not logged in
      this.setState({ loading: false });
    }
  }

  handleSelect(address) {
    this.setState({ selectedAddressId: address.id });
  }

  handleDelete(address, e) {
    e.stopPropagation();
    this.setState({
      selectedAddressForDelete: address,
      showDeleteConfirmModal: true,
    });
  }

  handleAdd() {
    this.setState({ showAddForm: true });
  }

  handleCancelAdd() {
    this.setState({ 
      showAddForm: false,
      newAddress: {
        street_address: '',
        city: '',
        state: '',
        zip_code: '',
        country: '',
        address_type: 'home',
        is_default: false,
      },
    });
  }

  handleAddressSelect(place) {
    // Parse Google Places API result
    const addressComponents = place.address_components || [];
    let streetNumber = '';
    let route = '';
    let city = '';
    let state = '';
    let zipCode = '';
    let country = '';

    addressComponents.forEach(component => {
      const types = component.types;
      if (types.includes('street_number')) {
        streetNumber = component.long_name;
      } else if (types.includes('route')) {
        route = component.long_name;
      } else if (types.includes('locality')) {
        city = component.long_name;
      } else if (types.includes('administrative_area_level_1')) {
        state = component.short_name;
      } else if (types.includes('postal_code')) {
        zipCode = component.long_name;
      } else if (types.includes('country')) {
        country = component.short_name;
      }
    });

    this.setState({
      newAddress: {
        ...this.state.newAddress,
        address_line_1: `${streetNumber} ${route}`.trim(),
        city,
        state,
        zip_code: zipCode,
        country,
      },
    });
  }

  handleSaveAddress() {
    const { newAddress, addresses } = this.state;
    
    if (!newAddress.street_address || !newAddress.city || !newAddress.state) {
      this.errorHandler('Please fill in all required fields');
      return;
    }

    // TODO: Implement actual save API call
    const newId = Math.max(...addresses.map(a => a.id), 0) + 1;
    const addressToSave = {
      ...newAddress,
      id: newId,
      display_name: newAddress.address_type === 'home' ? 'Home' : 'Work',
    };

    this.setState(state => ({
      addresses: [...state.addresses, addressToSave],
      showAddForm: false,
      newAddress: {
        street_address: '',
        city: '',
        state: '',
        zip_code: '',
        country: '',
        address_type: 'home',
        is_default: false,
      },
    }));
  }

  errorHandler(errorMsg) {
    this.setState({ error: errorMsg, showErrorModal: true });
  }

  closeErrorModal() {
    this.setState({ showErrorModal: false, error: '' });
  }

  handleFinishAddress(address) {
    this.setState({
      selectedAddressForFinish: address,
      showFinishAddressModal: true,
    });
  }

  closeFinishAddressModal() {
    this.setState({
      showFinishAddressModal: false,
      selectedAddressForFinish: null,
    });
  }

  handleFinishAddressSuccess() {
    // Reload addresses after successful update
    this.loadAddresses();
    this.closeFinishAddressModal();
  }

  handleSetDefault(address) {
    this.setState({
      selectedAddressForDefault: address,
      showDefaultConfirmModal: true,
    });
  }

  closeDefaultConfirmModal() {
    this.setState({
      showDefaultConfirmModal: false,
      selectedAddressForDefault: null,
    });
  }

  handleDefaultSuccess() {
    // Reload addresses after successful default update
    this.loadAddresses();
    this.closeDefaultConfirmModal();
  }

  handleDeleteConfirm(address) {
    this.setState({
      selectedAddressForDelete: address,
      showDeleteConfirmModal: true,
    });
  }

  closeDeleteConfirmModal() {
    this.setState({
      showDeleteConfirmModal: false,
      selectedAddressForDelete: null,
    });
  }

  handleDeleteSuccess(deletedAddress) {
    // Remove from local state and update UI
    this.setState(state => ({
      addresses: state.addresses.filter(a => a.id !== deletedAddress.id),
      selectedAddressId: state.selectedAddressId === deletedAddress.id ? null : state.selectedAddressId,
    }));
    
    if (this.props.onDelete) {
      this.props.onDelete(deletedAddress);
    }
    
    this.closeDeleteConfirmModal();
  }

  handleNewAddressFromAutocomplete(newAddress) {
    const {
      city, zipCode, cityId, addressLine1, state, country
    } = newAddress;
    
    if (!(zipCode && addressLine1 && (city || cityId) && state)) {
      this.setState({ error: 'Please select a location with a street address', showErrorModal: true });
      return;
    }

    // Create the address object for API
    const addressData = {
      address_line_1: addressLine1,
      city: city || cityId,
      state,
      zip_code: zipCode,
      country: country || 'US',
      address_type: 'home',
      default: false,
    };

    // Optimize by setting loading state immediately
    this.setState({ loading: true });

    // Call API to create the address
    addAddressForCurrentUser(addressData, (response) => {
      const { address, success, result } = response.data;
      
      if ((success || result) && address) {
        // Successfully created, now open finish modal to complete details
        this.setState({
          selectedAddressForFinish: address,
          showFinishAddressModal: true,
          addressError: '',
          loading: false
        });
        
        // Clear the input after successful submission
        if (this.addressInputRef.current && this.addressInputRef.current.clearInput) {
          this.addressInputRef.current.clearInput();
        }
      } else {
        this.setState({ 
          error: 'Failed to create address',
          showErrorModal: true,
          loading: false
        });
      }
    }, (err) => {
      console.log('Error creating address:', err);
      this.setState({ 
        error: 'Failed to create address',
        showErrorModal: true,
        loading: false
      });
    });
  }

  formatAddress(address) {
    const parts = [
      address.city,
      `${address.state || ''} ${address.zip_code || ''}`,
    ].filter(Boolean);
    
    return parts.join(', ');
  }

  render() {
    const { goBack } = this.props;
    const { 
      width, 
      addresses, 
      selectedAddressId, 
      showAddForm, 
      newAddress, 
      loading 
    } = this.state;
    const loggedIn = get(this.props, 'client.loggedIn', false);
    
    if (!loggedIn) {
      return (
        <SignupModal
          isSignin
          next={() => {
            window.location.reload();
          }}
        />
      );
    }
    
    return (
      <>
        <HelmetTag title="Address Book" />
        <NavbarRedesignForMarketplace notBooking showMenu />
        <MainBackgroundWrapper
          noMarginTop={width < 800}
          bgImagePath="#fff"
        >
          <div
            style={{
              marginLeft: width >= 1000 ? '15vw' : 0,
              padding: width >= 1000 ? '0' : '80px 16px',
              transition: 'margin-left 0.2s',
              minHeight: 'calc(100vh - 80px)',
            }}
          >
            <div className={`${width >= 800 ? 'max-width-47 p-24' : 'mb-48'}`}>
              {/* Header */}
              <div className="address-book-header">Address Book</div>
              
              {/* Add Address Input */}
              <div className="add-address-input-container">
                <div className="add-address-input">
                  <Search className="search-icon" />
                  <PlaceAutoCompleteInput
                    ref={this.addressInputRef}
                    hideIcon
                    uniqueId="address-book-adrs-list"
                    inputStylingClass={`add-address-input-field ${this.state.addressError ? 'error' : ''}`}
                    handleAddress={this.handleNewAddressFromAutocomplete}
                    placeholder="Select a new address then press Enter"
                    inCaseOfError={() => {
                      this.setState({ addressError: 'Please select a location with a street address' });
                    }}
                  />
                </div>
                {this.state.addressError && (
                  <div className="address-error">{this.state.addressError}</div>
                )}
              </div>
                {/* Saved Addresses Section */}
                <div className="saved-addresses-section">
                  <div className="saved-addresses-header medium-font">Saved Addresses</div>
                  
                  {/* Address List */}
                  <div className="addresses-list">
                    {addresses.slice().reverse().map((address, idx) => {
                      const isSelected = selectedAddressId === address.id;
                      return (
                        <div
                          key={address.id || idx}
                          className={`address-item ${isSelected ? 'selected' : ''}`}
                          onClick={() => this.handleSelect(address)}
                        >
                          <div className="address-content">
                            <div className='mr-8'>
                              <LocationOn className='w-h-20 contentSecondary'/>
                            </div>
                            <div className="address-text">
                              <div className="address-line-1">
                                {address.address_line_1}
                                {address.default && <span className="default-badge">Default</span>}
                              </div>
                              <div className="address-line-2">{this.formatAddress(address)}</div>
                              {(!address.parking_info || !address.parking_type) ? (
                                <div className="address-incomplete">
                                  <span className="incomplete-text">Incomplete - needs details</span>
                                </div>
                              ) : (
                                !address.default && (
                                  <div className="address-actions-secondary">
                                    <button
                                      type="button"
                                      className="set-default-link"
                                      onClick={e => {
                                        e.stopPropagation();
                                        this.handleSetDefault(address);
                                      }}
                                      aria-label="Set as default address"
                                    >
                                      Set as default
                                    </button>
                                  </div>
                                )
                              )}
                            </div>
                            <div className="address-actions">
                              <button
                                type="button"
                                className="edit-button"
                                onClick={e => {
                                  e.stopPropagation();
                                  this.handleFinishAddress(address);
                                }}
                                aria-label="Edit address details"
                              >
                                <Edit />
                              </button>
                              {!address.default && (
                                <button
                                  type="button"
                                  className="delete-button"
                                  onClick={e => this.handleDelete(address, e)}
                                  aria-label="Delete address"
                                >
                                  <DeleteOutline />
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                {/* Add Address Form */}
                {/*showAddForm && (
                  <div className="bg-white br-rd-8 p-16 mb-16">
                    <div className="size-18-28 font-weight-bold contentPrimary mb-16">Add New Address</div>
                    
                    <div className="mb-16">
                      <label className="size-14-20 contentSecondary mb-4 d-block">Address</label>
                      <PlaceAutoCompleteInput
                        placeholder="Enter address"
                        value={newAddress.street_address}
                        onPlaceSelect={this.handleAddressSelect}
                        className="form-control"
                      />
                    </div>

                    <div className="row">
                      <div className="col-xs-12 col-sm-6 mb-16">
                        <label className="size-14-20 contentSecondary mb-4 d-block">City</label>
                        <input
                          type="text"
                          className="form-control"
                          value={newAddress.city}
                          onChange={(e) => this.setState({
                            newAddress: { ...newAddress, city: e.target.value }
                          })}
                          placeholder="City"
                        />
                      </div>
                      <div className="col-xs-12 col-sm-6 mb-16">
                        <label className="size-14-20 contentSecondary mb-4 d-block">State</label>
                        <input
                          type="text"
                          className="form-control"
                          value={newAddress.state}
                          onChange={(e) => this.setState({
                            newAddress: { ...newAddress, state: e.target.value }
                          })}
                          placeholder="State"
                        />
                      </div>
                </div>

                    <div className="row">
                      <div className="col-xs-12 col-sm-6 mb-16">
                        <label className="size-14-20 contentSecondary mb-4 d-block">ZIP Code</label>
                        <input
                          type="text"
                          className="form-control"
                          value={newAddress.zip_code}
                          onChange={(e) => this.setState({
                            newAddress: { ...newAddress, zip_code: e.target.value }
                          })}
                          placeholder="ZIP Code"
                        />
                      </div>
                      <div className="col-xs-12 col-sm-6 mb-16">
                        <label className="size-14-20 contentSecondary mb-4 d-block">Address Type</label>
                        <select
                          className="form-control"
                          value={newAddress.address_type}
                          onChange={(e) => this.setState({
                            newAddress: { ...newAddress, address_type: e.target.value }
                          })}
                        >
                          <option value="home">Home</option>
                          <option value="work">Work</option>
                        </select>
                      </div>
                    </div>

                    <div className="d-flex-only justify-content-end">
                      <button
                        type="button"
                        className="btn btn-link mr-16"
                        onClick={this.handleCancelAdd}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn cta-primary"
                        onClick={this.handleSaveAddress}
                      >
                        Save Address
                      </button>
                    </div>
                  </div>
                )*/}
              </div>
              </div>
            </div>
        </MainBackgroundWrapper>

        {/* Error Modal */}
        {this.state.showErrorModal && (
          <ErrorModal
            isOpen={this.state.showErrorModal}
            close={this.closeErrorModal}
          >
            <p>{this.state.error}</p>
          </ErrorModal>
        )}

        {/* Finish Address Modal */}
        {this.state.showFinishAddressModal && (
          <FinishAddressModal
            isOpen={this.state.showFinishAddressModal}
            address={this.state.selectedAddressForFinish}
            onClose={this.closeFinishAddressModal}
            onSuccess={this.handleFinishAddressSuccess}
          />
        )}

        {/* Default Address Confirmation Modal */}
        {this.state.showDefaultConfirmModal && (
          <DefaultAddressConfirmModal
            isOpen={this.state.showDefaultConfirmModal}
            address={this.state.selectedAddressForDefault}
            onClose={this.closeDefaultConfirmModal}
            onSuccess={this.handleDefaultSuccess}
          />
        )}

        {/* Delete Address Confirmation Modal */}
        {this.state.showDeleteConfirmModal && (
          <DeleteAddressConfirmModal
            isOpen={this.state.showDeleteConfirmModal}
            address={this.state.selectedAddressForDelete}
            onClose={this.closeDeleteConfirmModal}
            onSuccess={this.handleDeleteSuccess}
          />
        )}

        {/* Loading Overlay */}
        <LoadingOverlay showLoader={this.state.loading} />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  client: state.client,
});

export default connect(mapStateToProps)(AddressBook);
